import React, { useState, useEffect } from 'react'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { width } from "../../../CustomComponents/DynamicCard/DynamicCardStyles";
import { useTranslation } from 'react-i18next';
import HomeLayout from '../../../Layout/HomeLayout';
import DynamicCard from '../../../CustomComponents/DynamicCard';
import HelpIcon from '../../../../assets/images/illo-help (1).png';
import LineBreaks, { addLineBreaks, ClimbManageSettingsSidebar, displayErrorMessage, generateClimbSettingsData, retrieveData } from '../../../../utils';
import Loader from '../../../CustomComponents/Loader';
import { useDispatch, useSelector, connect } from 'react-redux';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from "../../../../network/NetworkUtils";
import { AGREEMENTS, CLIMB_OPT_IN_OUT, COVERED_BY_KUDZU, COVERED_BY_KUDZU_PLUS, GET_CLIMB_FEATURES, SAVINGS_GOALS, SAVINGS_HABIT, SAVING_CARD_CODE, SPENDING_ALERT, STATUS_SUCCESS_CODE } from "../../../../network/URLConstants";
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import Modal from '../../../CustomComponents/Modal';
import SpendAlertsPause from "../../../../assets/images/illo-pause.png";
// import SpendAlertsPauseSuccess from '../../../../assets/images/illo-pause-done.png';
import RadialFill from '../../../../assets/images/Checkbox-blue.png'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { appTheme } from '../../../../helpers/utils/Utils';
import CardHeading from '../../../CustomComponents/CardHeading';
import CustomModalPlus from '../../../../kudzu_plus/helpers/customModalPlus';
import ArrowWhite from '../../../../assets/kudzu-plus-images/arrow-image.png';
import HelpPlus from '../../../../assets/kudzu-plus-images/HelpPlus.png';
import lockIcon from '../../../../assets/kudzu-plus-images/lock.png';
import coveredBykudzuplus1 from '../../../../assets/kudzu-plus-images/coveredBykudzuPlusGradientIntro1.png';
import coveredBykudzuplus2 from '../../../../assets/kudzu-plus-images/coveredBykudzuplus-2.png';
import debounce from 'lodash.debounce';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { getUserMembership } from '../../../../helpers/utils/Utils';
import { CHECKING_CARD_CODE } from '../../../../helpers/utils/Utils';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';

const ClimbSettings = () => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessToken = useSelector(state => state.accessToken);
    const [isClimbings, setisClimbings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const isPrimrayKey = cards !== null ? cards[0].CardKey : 0;
    const [selectedItem, setSelectedItem] = useState({})
    const [selectedIndex, setSelectedIndex] = useState(-1)
    const [selectedOptin, setSelectedOptin] = useState('')
    const [showAlert, setShowAlert] = useState(false)
    const [highlightMessage, setHighlightMessage] = useState('')
    const [strAlert, setStrAlert] = useState('')
    const [strMessage, setStrMessage] = useState('')
    const [strYesBtnText, setStrYesBtnText] = useState('')
    const [strCancelBtnText, setCancelBtnText] = useState('')
    const [modalHeading, setmodalHeading] = useState('');
    const [image, setImage] = useState('')
    const [alertContentText, setAlertContentText] = useState('')
    const [alertButtonText, setAlertButtonText] = useState('')
    const [isMobile, setIsMobile] = useState(true)
    const climbFeatures = useSelector(state => state.climbFeatures);
    const enabledClimbings = climbFeatures?.filter((response) => response.enabled === true);
    const isCoveredByKudzuOptedIn = enabledClimbings?.some(item => item.code === COVERED_BY_KUDZU && item.optedIn)
    const [showModel, setShowModel] = useState(false);
    const [modelImage, setModelImage] = useState('')
    const userId = useSelector(state => state.userId);
    const [loading, setLoading] = useState(false)
    const [modalBg, setModalBg]=useState('')
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-heads)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--subway-head)]";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--subway-head)]";
    const SubHeadingStyles2 = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] mb-4";
    const InputStyles = "font-hanken-grotesk  text-secondary-2 px-4 bg-text-btn placeholder-kudzu-blue lg:text-[16px] md:text-[15px] text-[14px] placeholder:font-semibold font-medium focus:outline-none w-full h-[60px]";
    const SubHeaderMsgStylesForSucces = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-[700] cursor-pointer pointer-events-none text-[var(--subway-head)]";

    // const SubHeadingStyles = "w-[90%] md:w-full font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-secondary-3";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [isSubComponent, setIsSubComponent] = useState(false);
    const [coveredBy,setCoveredBy] = useState(false);
    const savingsCardExist = cards?.some(item => item.AccountTypeName === "Savings")
    const savingsWithBalanceOver50 = cards.find(
        obj => obj.AccountTypeBit63 == 32 && obj.Balance >= 50
    );
    const [isCoveredByKudzuIneligibleSetupSavings, setIsCoveredByKudzuIneligibleSetupSavings] = useState(false);
    const [isCoveredByKudzuIneligibleSetupSavingsPostPopup, setIsCoveredByKudzuIneligibleSetupSavingsPostPopup] = useState(false);
    const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] = useState(false);

    const isCoveredByKudzuPlusEligible = isClimbings?.find(item => item?.code === COVERED_BY_KUDZU_PLUS);
    const issavingsGoalEligible = isClimbings?.find(item => item?.code === SAVINGS_GOALS);



    const HeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--headTennis-clr)]";
    const SubHeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStylesPlus = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const HeaderMsgStylesForPlus = "font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[13px] sm:text-[6px] text-[8px] font-[400] cursor-pointer pointer-events-none";
    const largeScreenMediaQuery = window.matchMedia('(min-width: 768px)');
    useEffect(() => {
        setIsMobile(largeScreenMediaQuery.matches); // Execute immediately if the screen size is already at or above 'sm'

    }, [])

    const [disclosureAgrmt, setDisclosureAgrmt] = useState(false);
    const [infoMessage, setinfoMessage] = useState('');
    const [showPolicys, setShowPolicys] = useState('terms');
    const [renderModel, setRenderModel] = useState('');
    const [policyURL, setPolicyURL] = useState('');
    const [showAgreementsModel, setShowAgreementsModel] = useState(false);
    const [isCoveredByKudzuDiscloserOpen, setIsCoveredByKudzuDiscloserOpen] = useState(false);
    const [carousel, setCarousel] = useState('');
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [subFooter, setSubFooter] = useState('');
    const [skipAndNextButtonsEnable, setSkipAndNextButtonsEnable] = useState(false);
    const [showLearnMoreButton, setShowLearnMoreButton] = useState(false);
    const [showActivateButton, setShowActivateButton] = useState(false);
    const [showToolTipForCbk, setShowToolTipForCbk] = useState(false);
    const [showToolTipForCbkPlus, setShowToolTipForCbkPlus] = useState(false);
    const [isCoveredByKudzuPlusModalOpen1, setIsCoveredByKudzuPlusModalOpen1] = useState(false);
    const [isCoveredByKudzuPlusModalOpen2, setIsCoveredByKudzuPlusModalOpen2] = useState(false);
    const [isCoveredByKudzuPlusIneligible, setIsCoveredByKudzuPlusIneligible] = useState(false);
    const CBKPlusObject = isClimbings?.filter((val) => val?.code == COVERED_BY_KUDZU_PLUS);
    const isCoveredByKudzuPlusOptedIn = enabledClimbings?.some(item => item.code === COVERED_BY_KUDZU_PLUS && item.optedIn)
    const isSavingsGoalsOptedIn = enabledClimbings?.some(item => item.code === SAVINGS_GOALS && item.optedIn)
    const accessTokenToApi = useSelector(state => state.accessToken);
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const userMembershipData = getUserMembership(loggedResponse)


    const handleTermsClick = () =>{
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
            return;
        }
        else {
            navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions',
                    url:
                        userMembershipData?.membershipType === "Plus" ||
                            userMembershipData?.membershipType === "Trial"
                            ? "CoveredByKudzuPlusTerms"
                            : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey } });

        }
    }


    const getAgreementsBasedOnType = async (url) => {
        if (isPrimrayKey == undefined || isPrimrayKey == null) {
            return
        }
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        setIsLoading(true)

        // let finalUrl = (PROGRAM_CONTENT + "?accountType=64&language=en&contentType=" + url + "&programKey=200")
        let finalUrl = AGREEMENTS.replace('{contentType}', url).replace('{cardKey}', isPrimrayKey)
        var response = await GetRequest(finalUrl, headers)
        var responseObj = JSON.parse(response)
        setIsLoading(false)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setRenderModel(responseObj.Response.RenderModel);
            setPolicyURL(responseObj.Response.Content);
            setShowAgreementsModel(true);
        } else {
            setTimeout(() => {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                // setError(displayText)
            }, 500);
        }
    }


    const handleClick = (type) => {
        setIsCoveredByKudzuDiscloserOpen(false);
        setShowPolicys((prevState) => {
            if (type === 'userAgreement') {
                LinkClick("user agreement");
            }
        });

    };

    const LinkClick = (href) => {
        // e.preventDefault();
        // e.stopPropagation();

                            switch (href) {
                case "user agreement":
                    getAgreementsBasedOnType("CoveredByKudzuTerms")
                    break;

                default:
                    break;
            }
        };

    const handleClimbFeatures = async () => {
        if (isPrimrayKey == undefined || isPrimrayKey == null) {
            return
        }
        //  debugger;
        setIsLoading(true);
        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey)
        const response = await GetRequest(url, headers);
        const responseJson = JSON.parse(response);
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
            //   debugger;
            const enabledClimbings = responseJson.Response.filter(
                (response) => response.enabled === true

            );
            setisClimbings(enabledClimbings);
            dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
            setIsLoading(false);
        } else {
            return [];
        }

    }

    // Set document title based on current route
    const documentTitle = location.pathname.includes('/Toolkit/ToolkitSettings') 
        ? t('page_title_Toolkit_Settings') 
        : t('page_title_manage_settings');

    useDocumentTitle(documentTitle);

    useEffect(() => {
        handleClimbFeatures();
    }, [])

    // debugger;

    const SettingsData = isClimbings.map(item => generateClimbSettingsData(item));

    var ManageSettingsbuttonLabels = [
        { label: 'SpendSense Alerts', link: '/Toolkit/ManageSpendAlerts' },
        // { label: 'Covered by Kudzu', link: (isCoveredByKudzuOptedIn || isCoveredByKudzuPlusOptedIn) ? '/Toolkit/ManageCoveredByKudzu' : '/Toolkit/CoveredByKudzu' },
        { label: 'Covered by Kudzu', link: kudzuPlusTrue ? (isCoveredByKudzuOptedIn || isCoveredByKudzuPlusOptedIn) ? '/Toolkit/ManageCoveredByKudzu' : '/Toolkit/CoveredByKudzu' : isCoveredByKudzuOptedIn ? '/Toolkit/ManageCoveredByKudzu' : '/Toolkit/CoveredByKudzu' },
        { label: 'Savings Habits', link: '/Toolkit/ManageSavingsHabit' },
        ...(issavingsGoalEligible ? [{ label: 'Savings Goals', link: isSavingsGoalsOptedIn ? '/Toolkit/SavingGoals/ManageSavingGoal' : '/Toolkit/SavingGoals/ManageSavingGoal' }] : []),
    ];


    // Opt In modal
    const [isOptInModalOpen, setIsOptInModalOpen] = useState(false);
    const [isOptInWelcomBackModalOpen, setIsOptInWelcomeBackModalOpen] = useState(false);

    const openOptInModal = () => {
        setIsOptInModalOpen(true);
    };

    const closeOptInModal = () => {
        // alert('fasle the optin modal');
        handleClimbFeatures();
        setIsOptInModalOpen(false)
        setIsOptInWelcomeBackModalOpen(false);
    };

    // Opt out modal
    const [isOptOutModalOpen, setIsOptOutModalOpen] = useState(false);

    const openOptOutModal = () => {
        setIsOptOutModalOpen(true);
    };

    const closeOptOutModal = async () => {
        debugger
        if (alertContentText == t('you_can_opt_back_in_covered_by_kudzu')) { setIsOptOutModalOpen(false); await handleClimbFeatures(); let coveredByKudzuDate = SettingsData[1]; toggleOnOrOff(coveredByKudzuDate.code, coveredByKudzuDate.optinStatus) }
        else {
            handleClimbFeatures();
            setIsOptOutModalOpen(false)
        }
    };


    const handleToggleButton = (index, item, optIn,hasEverOptedIn) => {
        debugger;
        setSelectedIndex(index)
        setSelectedItem(item)
        setSelectedOptin(optIn)
        if (optIn) {
            if (item == SPENDING_ALERT) {
                logFirebaseEvents("Climb_settings", "Spending_Alert_optout_Clicked", "Spending_Alert_optout_Clicked", "", "");
                openOptInModal();
                setmodalHeading(t('please_confirm_pause_spending_alert'));
                setAlertContentText(t('pausing_will_stop_spendsense_update'))
                setAlertButtonText(t('pause_sependsense_alert'))
            }
            else if (item == SAVINGS_HABIT) {
                logFirebaseEvents("Climb_settings", "Savings_Habit_optout_Clicked", "Savings_Habit_optout_Clicked", "", "");
                openOptInModal();
                setmodalHeading(t('need_to_press_pause_savings_habit'));
                setAlertContentText(t('pausing_will_stop_these_transfers_savings_habit'))
                setAlertButtonText(t('pause_savings_habit'))
            }
            else if (item == COVERED_BY_KUDZU_PLUS) {
                logFirebaseEvents("Climb_settings", "Covered_By_Kudzu_Plus_optout_clicked", "Covered_By_Kudzu_Plus_optout_clicked", "", "");
                openOptInModal();
                setmodalHeading(t('CoverdByKudzuPlusPauseMessage'));
                setAlertContentText (<>{(t('CBK_PLUS_SUB_HEADING'))}<Link to='/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions' state={{ name: 'Covered by Kudzu Terms and Conditions',
                    url:
                        userMembershipData?.membershipType === "Plus" ||
                            userMembershipData?.membershipType === "Trial"
                            ? "CoveredByKudzuPlusTerms"
                            : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey }} className='underline cursor-pointer'>{addLineBreaks(t("CBK_PLUS_LINK"))}</Link>{t("You_can_opt")}</>)
                setAlertButtonText(t('pause_covered_by_kudzuPlus'))
            }
            else if (item == SAVINGS_GOALS) {
                logFirebaseEvents("Climb_settings", "savings_goal_optout_clicked", "savings_goal_optout_clicked", "", "");
                // toggleOnOrOff(item, optIn)
                openOptInModal();
                setmodalHeading(t('please_confirm_pause_savings_goals'));
                setAlertContentText(t('pausing_will_stop_savings_goals'))
                setAlertButtonText(t('pause_savings_goals'))
            }
            else {
                logFirebaseEvents("Climb_settings", "Covered_By_Kudzu_optout_clicked", "Covered_By_Kudzu_optout_clicked", "", "");
                openOptInModal();
                setmodalHeading(t('CoverdByKudzuPauseMessage'));
                setAlertContentText(t('opting_out_of_covered_by_kudzu'))
                setAlertButtonText(t('pause_covered_by_kudzu'))
            }
        } else {
            if (item == SPENDING_ALERT) {
                logFirebaseEvents("Climb_settings", "Spending_Alert_optin_Clicked", "Spending_Alert_optin_Clicked", "", "");
                toggleOnOrOff(item, optIn)
            } else if (item == SAVINGS_HABIT && !savingsCardExist) {
                logFirebaseEvents("Climb_settings", "Savings_Habit_inEligible_Clicked", "Savings_Habit_inEligible_Clicked", "", "");
                closeOptInModal()
                setIsCoveredByKudzuIneligibleSetupSavings(true);
                //  showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('enroll_in_savings_account'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
            } else if (item == SAVINGS_HABIT && savingsCardExist) {
                logFirebaseEvents("Climb_settings", "Savings_Habit_optin_Clicked", "Savings_Habit_optin_Clicked", "", "");
                toggleOnOrOff(item, optIn)
            }
            else if (item == COVERED_BY_KUDZU) {
                if (!savingsCardExist) {
                    logFirebaseEvents("Climb_settings", "Covered_By_Kudzu_InEligible_clicked", "Covered_By_Kudzu_InEligible_clicked", "", "");
                    closeOptInModal()
                    setIsCoveredByKudzuIneligibleSetupSavings(true);
                    //  showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('enroll_in_savings_account'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
                }else{
                    logFirebaseEvents("Climb_settings", "Covered_By_Kudzu_optin_clicked", "Covered_By_Kudzu_optin_clicked", "", "");
                    setIsCoveredByKudzuDiscloserOpen(true);
                }


            }
            else if (item == COVERED_BY_KUDZU_PLUS) {
                if (!isCoveredByKudzuPlusEligible) {
                    closeOptInModal()
                    setIsCoveredByKudzuIneligibleSetupSavings(true);
                    logFirebaseEvents("Climb_settings", "Covered_By_Kudzu_Plus_inEligible_clicked", "Covered_By_Kudzu_Plus_inEligible_clicked", "", "");
                    //  showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('enroll_in_savings_account'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
                } else {
                    if (hasEverOptedIn) {
                        logFirebaseEvents("Climb_settings", "Covered_By_Kudzu_Plus_Welcome_Modal__clicked", "Covered_By_Kudzu_Plus_Welcome_Modal__clicked", "", "");
                        setIsOptInWelcomeBackModalOpen(true)
                    }
                    else {
                        logFirebaseEvents("Climb_settings", "Covered_By_Kudzu_Plus_optin_clicked", "Covered_By_Kudzu_Plus_optin_clicked", "", "");
                        setIsCoveredByKudzuDiscloserOpen(true);
                    }
                }
                // if (!savingsCardExist) {
                //     closeOptInModal()
                //     setIsCoveredByKudzuIneligibleSetupSavings(true);
                //   //  showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('enroll_in_savings_account'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
                // }else{
                //     setIsCoveredByKudzuDiscloserOpen(true);
                // }


            }
            else if (item == SAVINGS_GOALS) {
                logFirebaseEvents("Climb_settings", "savings_goals_optin_clicked", "savings_goals_optin_clicked", "", "");
                toggleOnOrOff(item, optIn)
            }
        }

    }

    ////call the apis based on the selections
    const toggleOnOrOff = async (item, optIn) => {
        debugger;
        setIsLoading(true)
        var url = "";
        if (!optIn) {
            url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey) + item + '/opt-in'
        } else {
            url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey) + item + '/opt-out'
        }
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const response = await PostRequest(url, {}, headers);
        const responseObj = JSON.parse(response)
        // debugger;
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setIsLoading(false)
            if (item == COVERED_BY_KUDZU) {
                if (optIn) {
                    closeOptInModal();
                    openOptOutModal();
                    setmodalHeading(t('covered_by_kudzu_paused'));
                    // setAlertContentText(t('you_can_opt_back_in_covered_by_kudzu'))
                    setAlertContentText(t('opt_out_of_covered_by_kudzu_msg'))
                    setAlertButtonText(t('back_to_climb'))
                } else {
                    handleClimbFeatures();
                }
            }
            if (item == COVERED_BY_KUDZU_PLUS) {
                if (optIn) {
                    closeOptInModal();
                    openOptOutModal();
                    setmodalHeading(addLineBreaks(t('covered_by_kudzu_Plus_paused')));
                    setAlertContentText(t('you_may'))
                    setAlertButtonText(t('back_to_climb'))
                } else {
                    handleClimbFeatures();
                }
            }
            else if (item == SAVINGS_HABIT) {
                if (optIn) {
                    closeOptInModal();
                    openOptOutModal();
                    setmodalHeading(t('your_savings_habits_have_been_paused'));
                    setAlertContentText(t('you_can_resume_savings'))
                    setAlertButtonText(t('Back_to_Toolkit'))
                } else {
                    handleClimbFeatures();
                }
            } if (item == SPENDING_ALERT) {
                if (optIn) {
                    closeOptInModal();
                    openOptOutModal();
                    setmodalHeading(t('your_spendsense_alerts_have_been_paused'));
                    setAlertContentText(t('you_can_resume_spendsense'))
                    setAlertButtonText(t('Back_to_Toolkit'))
                } else {
                    handleClimbFeatures();
                }
            }
            else if (item == SAVINGS_GOALS){
                if (optIn) {
                    closeOptInModal();
                    openOptOutModal();
                    setmodalHeading(t('your_savings_goals_have_been_paused'));
                    setAlertContentText(t('you_can_resume_savings_goals'))
                    setAlertButtonText(t('Back_to_Toolkit'))
                } else {
                    handleClimbFeatures();
                }
            }

        }
    }


    const handleTermsClicks = () =>{
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
            return;
        }
        else {
            navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions',
                    url:
                        userMembershipData?.membershipType === "Plus" ||
                            userMembershipData?.membershipType === "Trial"
                            ? "CoveredByKudzuPlusTerms"
                            : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey } });

        }
    }

    const optinSuccessPopMessageFun = (isCbk) => {
        return (
            <>
                {isCbk ? (
                    <>
                        <span className={SubHeaderMsgStyles}>{t('Once_you_reach_your_Covered_Plus')}</span>{" "}
                        <span className={SubHeaderMsgStylesForSucces}>{t('covered_by_kudzu_plus')}</span>{" "}
                        <span className={SubHeaderMsgStyles}>{t('will_spot_you_up_to_$100_to_cover_plus')}</span>
                    </>
                ) :
                    (
                        <>
                            <span className={SubHeaderMsgStylesForSucces}>{t('covered_by_kudzu_plus')}</span> {" "}
                            <span className={SubHeaderMsgStyles}>{t('will_spot_you_up_to_$100_to_cover_plus')}</span>
                        </>
                    )}
            </>
        );
    };


    const coveredByKudzuOptIn = async (item,isCbkOptIn) => {
        debugger
        if (cards == null || cards == undefined) {
            return
        }
        setIsLoading(true);
        if(item === COVERED_BY_KUDZU){
            var url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey) + 'CoveredByKudzu' + '/opt-in'
        }
        else{
            var url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey) + 'CoveredByKudzuPlus' + '/opt-in'
        }
        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const response = await PostRequest(url, {}, headers)

        setTimeout(() => {
            setIsLoading(false)
        }, 500);

        const responseObj = JSON.parse(response);

        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setDisclosureAgrmt()
            setIsCoveredByKudzuDiscloserOpen(false);
            // setIsCoveredByKudzuOptInSuccess(true);
            (item === COVERED_BY_KUDZU) ? setCoveredBy(false) : setCoveredBy(true);

            showAlertModal(true, t('congrats'), item === COVERED_BY_KUDZU ?  t("u_r_now_cbk") : t('u_r_now_cbk_plus') , item === COVERED_BY_KUDZU ? t('covered_by_kudzu_content2') : optinSuccessPopMessageFun(isCbkOptIn), true, false, showActivateButton ? t('back_to_climb') : t('back_to_climb'),'', true, item === COVERED_BY_KUDZU ? appThemeData.isbtnprim : appThemeData.diag, 'bg-[var(--modals-bg)]')

        } else {
            setIsCoveredByKudzuDiscloserOpen(false);
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("covered_by_cudzu"), displayText, '', true, false, t("home"), '', true, require('../../../../assets/images/warning.png'), false, false)
        }

    }

    const Headingcom = () => {
        return (
            <div className="relative">
                <div className={`flex flex-col justify-start my-16 sm:my-6 md:my-10 mx-8`}>

                    <p className='font-hanken-grotesk font-[500] 
                        text-[16px] leading-[24px] sm:font-[600] 
                        sm:text-[15px] sm:leading-[23px] md:font-[500] 
                        md:text-[26px] md:leading-[36px]'>{t("Toolkit_Settings")}</p>



                </div>

            </div>

        )
    }

    const onAcptBtnClick = async () => {
        if (btn1Text == t('enroll_in_savings_account')) { navigate('/SetupSavingsAccount'); closeModel() }
        if (btn1Text == t('back_to_climb')) { navigate('/Toolkit/ToolkitMenu'); closeModel() }
        if (btn1Text == t('setup_direct_deposit') ) { navigate("/AccountServices/Spending/ManageDirectDeposit"); closeModel() }
    }
    const onCancelBtnClick = () => {
        if (btn2Text == t('back_to_climb')) { navigate('/Toolkit/ToolkitMenu'); closeModel() }

    }
    const closeModel = () => {
        setIsCoveredByKudzuDiscloserOpen(false);
        setShowModel(false);
        handleClimbFeatures();
        navigate('/Toolkit/ToolkitSettings');
    }

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, modalBg) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setModalBg(modalBg)
    }

    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage,subFooter) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)
        setLargeImage(largeImage)
        setSubFooter(subFooter)
    }



    const closeSkipModal = () => {
        navigate('/home');
    };

    const closeCustomAlertModal = () => {
        setShowModel(false);
        // if (highlightMsg == t('covered_by_cudzu')) { 
        navigate('/Toolkit/ToolkitMenu');
        //  }
    }
    const closeCBKPlusModals = () => {
        setIsCoveredByKudzuPlusModalOpen1(false)
        setIsCoveredByKudzuPlusModalOpen2(false)
    }
    const clickedItem = (item) => {

        if (item.link.toLowerCase() == '/climb/managesavingshabit') {

            if (!savingsCardExist && item.label == "Savings Habits") {
                closeOptInModal()
                setIsCoveredByKudzuIneligibleSetupSavings(true);
                //  showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('enroll_in_savings_account'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
            }else if (!savingsCardExist && item.label == "Covered by Kudzu") {
                closeOptInModal()
                setIsCoveredByKudzuIneligibleSetupSavings(true);
                //  showAlertModal(true, t('sorry'), t("it_looks_like_your_not_eligible_right_now"), LineBreaks(t("you_need_savings_account")), true, true, t('enroll_in_savings_account'), t('back_to_climb'), true, require('../../../../assets/images/covered_by_kudzu_ineligible.png'), '', false, true)
            }
            else if (savingsCardExist && savingsWithBalanceOver50 == undefined && item.label == "Covered by Kudzu") {
                closeOptInModal()
                setIsCoveredByKudzuIneligible(true);
            }else{
                navigate(item.link);
            }
        }else{
            navigate(item.link);
        }

    }

    const closeModelPlus = () => {
        setShowPlusModal(false)
        navigate('/home');
    }
    const onAcptBtnClickPlusModal = () => {

    }

    const onCancelBtnClickPlusModal = () => {

    }


    useEffect(() => {
        if (CBKPlusObject != undefined && CBKPlusObject?.length > 0) {
            const isEligible = CBKPlusObject[0].isEligible
            const hasEverOptedIn = CBKPlusObject[0].hasEverOptedIn
            //  setEverOptedIn(hasEverOptedIn)
            const optedIn = CBKPlusObject[0].optedIn
            if (!isEligible && !optedIn) {
                setShowLearnMoreButton(true)
            } else if (!hasEverOptedIn && !optedIn) {
                setShowActivateButton(true)
            } else {
                setShowActivateButton(false)
                setShowLearnMoreButton(false)
                //-----------displaying existing toggle--------
            }
        }
    }, [CBKPlusObject])

    const handleToolTipForCBK = () => {
        if (showToolTipForCbk) {
            setShowToolTipForCbkPlus(false)
            setShowToolTipForCbk(false)
        }
        else {
            setShowToolTipForCbkPlus(false)
            setShowToolTipForCbk(true)
        }
    }
    const handleToolTipForCBKPlus = () => {
        if (showToolTipForCbkPlus) {
            setShowToolTipForCbk(false)
            setShowToolTipForCbkPlus(false)
        }
        else {
            setShowToolTipForCbk(false)
            setShowToolTipForCbkPlus(true)
        }

    }

    const handleActivateCoveredByKudzuPlus = () => {
        setIsCoveredByKudzuPlusModalOpen1(false)
        setIsCoveredByKudzuPlusModalOpen2(false)
        if (showActivateButton) {
            setIsCoveredByKudzuPlusIneligible(false)
            setIsCoveredByKudzuDiscloserOpen(true);

        }
        else {
            setIsCoveredByKudzuDiscloserOpen(false);
            setIsCoveredByKudzuPlusIneligible(true)
        }
    }


    return (
        <>
            <HomeLayout>
                <ClimbManageSettingsSidebar indexBtn={0} ManageSettingsbuttonLabels={ManageSettingsbuttonLabels} headingMessage={true} navigateClicked={clickedItem} />

                <div className='flex flex-col md:w-[860px] sm:w-[464px] 
            w-[100%] animate__animated animate__fadeInRight '>
                    <DynamicCard
                        header={false}
                        CardRadius={true}
                        cardWidth={width.homeCard}
                        footer={true}
                        HeaderRadius={true}
                        // backgroundColor={!isMobile ? '#fffff' : 'rgba(75, 112, 185, 0.1)'}
                        // HeaderContent={
                        //     <div className='flex justify-center h-[inherit]'>
                        //         <div className='lg:w-[70%] md:w-[86%] w-full flex items-center'>
                        //             <p className='font-[500] 
                        // lg:text-[26px] md:text-[22px] 
                        // sm:text-[18px] text-[20px] leading-[36px] font-hanken-grotesk 
                        // sm:px-0 '>{t('Climb_sttings')}</p>
                        //         </div>
                        //     </div>} 
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        backgroundColor={'--cardHeading-bg'}
                        HeaderContent={
                            <>
                                <CardHeading heading={t("Toolkit_Settings")} />
                            </>
                        }
                    //  HeaderContent={Headingcom()}
                    // backgroundColor={'#E4EAF5'}
                    >

                        <>
                            <div className='w-full justify-center flex sm:mt-1'>
                                <div className='lg:w-[70%] md:w-[86%] w-full'>
                                    <hr className='border-b-[2px] sm:hidden border-[#94C3E8] border-opacity-[65%] w-full' />
                                    {!kudzuPlusTrue && SettingsData.map((settings, index) => (
                                        <div key={index} className={`md:mt-10 mt-12 flex justify-between h-[123px] ${index < SettingsData.length-1 && 'border-b-[2px] border-[var(--climbBorder-botttom-clr)] border-opacity-[50%] sm:border-opacity-[75%]'}`}>
                                            <div>
                                                <p className='md:text-[20px] md:leading-[30px] sm:text[13px] sm:leading-[19px]
                                                     text-[16px] font-hanken-grotesk 
                                                    leading-[24px] font-600 md:font-[500] text-[var(--climbSettingsTitle)]'>
                                                    {settings.title}
                                                </p>
                                                <div className='lg:w-[410px] sm:w-[321px] w-[240px] mt-4 md:text-[14px] 
                                                     sm:text-[10px] text-[14px] 
                                                    font-hanken-grotesk md:leading-[22px]
                                                     sm:leading-[16px] leading-[20px] font-[500] md:font-[400] text-[var(--climb-font-clr)]'>
                                                    {settings.content}
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor={`setting-${settings.code}`} className="relative inline-flex items-center cursor-pointer">
                                                                <input
                                                                    id={`setting-${settings.code}`}
                                                                    name={`setting-${settings.code}`}
                                                                    type="checkbox"
                                                                    value={settings.code}
                                                                    checked={settings.optinStatus}
                                                                    onChange={(e) => handleToggleButton(index, settings.code, settings.optinStatus)}
                                                                    className="sr-only peer"
                                                                    aria-label={`Toggle ${settings.title}`}
                                                                />
                                                    {settings.optinStatus ? (
                                                        <>
                                                            <img src={appThemeData.Toggle_Selected} alt="" className="hidden sm:block" />
                                                            <img src={appThemeData.Toggle_Mobile_Selected} alt="" className="block sm:hidden" />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={appThemeData.Toggle} alt="" className="hidden sm:block" />
                                                            <img src={appThemeData.Toggle_Mobile} alt="" className="block sm:hidden" />
                                                        </>

                                                    )}

                                                    <span className="ml-3 text-sm font-medium text-gray-900
                                     dark:text-gray-300"></span>
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                    {kudzuPlusTrue && SettingsData.flatMap((settings, index) => {
                                        if (!settings.title || !settings.content) {
                                            return [];
                                        }
                                        const isCoveredByKudzu = settings.code === COVERED_BY_KUDZU;
                                        const isLast = index === SettingsData.length - 1;
                                        const isCoveredByPlus = isClimbings?.find(settings => settings?.code === COVERED_BY_KUDZU_PLUS);
                                        const baseItem = (
                                            <div
                                                key={index}
                                                className={`md:mt-10 mt-12 flex justify-between h-[123px] ${!isCoveredByKudzu && !isLast ? 'border-b-[2px] border-[var(--climbBorder-botttom-clr)] border-opacity-[50%] sm:border-opacity-[75%]' : ''
                                                    }`}
                                            >
                                                <div>
                                                    <p className="md:text-[20px] md:leading-[30px] sm:text[13px] sm:leading-[19px] text-[16px] font-hanken-grotesk leading-[24px] font-600 md:font-[500] text-[var(--climbSettingsTitle)]">
                                                        {settings.title}
                                                    </p>
                                                    <div className="lg:w-[410px] sm:w-[321px] w-[240px] mt-4 md:text-[14px] sm:text-[10px] text-[14px] font-hanken-grotesk md:leading-[22px] sm:leading-[16px] leading-[20px] font-[500] md:font-[400] text-[var(--climb-font-clr)]">
                                                        {settings.content}
                                                    </div>
                                                </div>
                                                {(!isCoveredByKudzu) && (
                                                    <div>
                                                        <label htmlFor={`setting-kudzu-plus-${settings.code}`} className="relative inline-flex items-center cursor-pointer">
                                                                            <input
                                                                                id={`setting-kudzu-plus-${settings.code}`}
                                                                                name={`setting-kudzu-plus-${settings.code}`}
                                                                                type="checkbox"
                                                                                value={settings.code}
                                                                                checked={settings.optinStatus}
                                                                                onChange={(e) =>
                                                                                    handleToggleButton(index, settings.code, settings.optinStatus)
                                                                                }
                                                                                className="sr-only peer"
                                                                                aria-label={`Toggle ${settings.title}`}
                                                                            />
                                                            {
                                                                settings.optinStatus ? (
                                                                    <>
                                                                    <img src={appThemeData.Toggle_Selected} alt="" className="hidden sm:block" />
                                                                    <img src={appThemeData.Toggle_Mobile_Selected} alt="" className="block sm:hidden" />
                                                                    </>
                                                                    ) : (
                                                                    <>
                                                                    <img src={appThemeData.Toggle} alt="" className="hidden sm:block" />
                                                                    <img src={appThemeData.Toggle_Mobile} alt="" className="block sm:hidden" />
                                                                    </>
                                                                    )
                                                            }

                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        );

                                        if (isCoveredByKudzu) {
                                            return [
                                                baseItem,
                                                <div
                                                    key={`additional-1-${index}`}
                                                    className="md:mt-6 mt-9 flex justify-between"
                                                >
                                                    <div>
                                                        <p className="flex items-center md:text-[19px] md:leading-[30px] sm:text[13px] sm:leading-[19px] text-[16px] font-hanken-grotesk leading-[24px] font-600 md:font-[500] text-[var(--climbSettingsTitle)]">
                                                            {t('fromsavings')} <img src={HelpPlus} alt='' className='pl-5 cursor-pointer' onClick={handleToolTipForCBK} />
                                                        </p>
                                                        { showToolTipForCbk &&
                                                            <button 
                                                                type="button"
                                                                className={`sm:ml-[98px] absolute ml-[80px] mt-[10px] w-[150px] font-hanken-grotesk leading-4
                                                                 font-bold 
                                                                p-[16px] bg-[#2965FB] text-white text-[12px] rounded-xl
                                                                  shadow-lg  z-10 cursor-pointer transition-all duration-1000`} 
                                                                onClick={() => setShowToolTipForCbk(false)}
                                                                aria-label="Close tooltip"
                                                            >
                                                                <div className="tooltip-arrow"></div>
                                                                {t('Covered_by_Kudzu_automatically_transfers')}
                                                            </button>}
                                                    </div>
                                                    <div>
                                                        <label htmlFor="setting-from-savings" className="relative inline-flex items-center cursor-pointer">
                                                            <input
                                                                id="setting-from-savings"
                                                                name="setting-from-savings"
                                                                type="checkbox"
                                                                value="from-savings"
                                                                checked={settings.optinStatus}
                                                                onChange={(e) =>
                                                                    handleToggleButton(index, settings.code, settings.optinStatus)
                                                                }
                                                                className="sr-only peer"
                                                                aria-label="Toggle from savings"
                                                            />
                                                            {
                                                                 settings.optinStatus ? (
                                                                    <>
                                                                    <img src={appThemeData.Toggle_Selected} alt="" className="hidden sm:block" />
                                                                    <img src={appThemeData.Toggle_Mobile_Selected} alt="" className="block sm:hidden" />
                                                                    </>
                                                                    ) : (
                                                                    <>
                                                                    <img src={appThemeData.Toggle} alt="" className="hidden sm:block" />
                                                                    <img src={appThemeData.Toggle_Mobile} alt="" className="block sm:hidden" />
                                                                    </>
                                                                    )
                                                            }                                                        </label>

                                                    </div>
                                                </div>,
                                                <div
                                                    key={`additional-2-${index}`}
                                                    className="md:mt-14 mt-9 flex justify-between border-b-[2px] border-[var(--climbBorder-botttom-clr)] border-opacity-[50%] sm:border-opacity-[75%] h-[95px]"
                                                >
                                                    <div>
                                                        <p className="flex items-center md:text-[19px] md:leading-[30px] sm:text[13px] sm:leading-[19px] text-[16px] font-hanken-grotesk leading-[24px] font-600 md:font-[500] text-[var(--climbSettingsTitle)]">
                                                            {t('fromKudzu+')} <button type="button" className='pl-5 cursor-pointer' onClick={handleToolTipForCBKPlus} aria-label="Help information for Kudzu+ coverage"><img src={HelpPlus} alt='' aria-hidden="true" /></button>
                                                        </p>
                                                        { showToolTipForCbkPlus &&
                                                            <button 
                                                                type="button"
                                                                className={`sm:ml-[98px] absolute ml-[80px] mt-[10px] w-[210px] font-hanken-grotesk leading-4
                                                                 font-bold 
                                                                p-[16px] bg-[#2965FB] text-white text-[13px] rounded-xl
                                                                  shadow-lg  z-10 cursor-pointer transition-all duration-1000`} 
                                                                onClick={() => setShowToolTipForCbkPlus(false)}
                                                                aria-label="Close tooltip"
                                                            >
                                                                <div className="tooltip-arrow"></div>
                                                                {t('Once_Savings_coverage_is_exhausted')}
                                                            </button>}
                                                    </div>
                                                    <div>
                                                        { showLearnMoreButton ?  <button className='borderGradient flex gap-[6px] px-[14px] py-[7px] font-hanken-grotesk text-[10px]' onClick={() => {logFirebaseEvents("Climb_settings", "Learn_More_Clicked", "Learn_More_Clicked", "", ""); setIsCoveredByKudzuPlusModalOpen1(true)}}>{t('learn_more_covered')}<img src={lockIcon} alt='lockIcon'/></button> :
                                                            showActivateButton ? <button className='borderGradient flex gap-[6px] px-[25px] py-[7px] font-hanken-grotesk text-[10px]' onClick={() => {logFirebaseEvents("Climb_settings", "Activate_Clicked", "Activate_Clicked", "", ""); setIsCoveredByKudzuPlusModalOpen1(true)}}>{t('activate')}</button> :
                                                                ( isCoveredByPlus &&
                                                                    <label htmlFor={`setting-kudzu-plus-coverage-${isCoveredByPlus.code}`} className="relative inline-flex items-center cursor-pointer">
                                                                    <input
                                                                        id={`setting-kudzu-plus-coverage-${isCoveredByPlus.code}`}
                                                                        name="setting-kudzu-plus-coverage"
                                                                        type="checkbox"
                                                                        value={isCoveredByPlus.code}
                                                                        checked={isCoveredByPlus?.optedIn}
                                                                        onChange={(e) =>
                                                                            handleToggleButton(index, isCoveredByPlus?.code, isCoveredByPlus?.optedIn,isCoveredByPlus.hasEverOptedIn)
                                                                        }
                                                                        className="sr-only peer"
                                                                        aria-label="Toggle from Kudzu+ coverage"
                                                                    />
                                                                        <div className="w-[38px] h-[25px] bg-[var(--climb-button-unchecked-bg-clr)] bg-opacity-[40%] peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-[var(--climb-button-slide-check-clr)] peer-checked:after:bg-[var(--climb-button-slide-check-clr)] peer-checked:after:left-[-6px] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:right-0 after:bg-[var(--climb-button-slide-unchecked-clr)] after:border-[var(--climb-button-slide-unchecked-clr)] after:border after:rounded-full after:h-[21px] after:w-[21px] after:transition-all dark:border-gray-600 peer-checked:bg-[var(--climb-button-slide-checked-bg-clr)] peer-checked:bg-opacity-[40%]"></div>
                                                                    </label>)}
                                                    </div>
                                                </div>,
                                            ];
                                        }

                                        return baseItem;
                                    })}
                                </div>
                            </div>

                            <div className='w-full flex sm:justify-end justify-between
                             md:h-[160px] sm:h-[120px] h-[140px] items-center md:gap-20 sm:gap-12'>
                                <Link to='/Toolkit/ToolkitMenu' className='lg:text-[18px] md:text-[17px] 
                                sm:text-[15px] text-[16px] font-[700]
                                 font-hanken-grotesk
                                 text-[var(--climb-back-clr)]' onClick={() => {  logFirebaseEvents("Climb_settings", "Back_Clicked", "Back_Clicked", "", ""); }}>
                                    {t('Back')}</Link>
                            </div>

                        </>
                    </DynamicCard>
                </div>
            </HomeLayout>
            <CustomAlertModel
                isOpen={showModel}
                onClose={closeModel}
                image={modelImage}
                highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                HeaderMsg={<p className={`${HeaderMsgStyles} ${coveredBy ? '!w-[436px]' : ''}`}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                showErrorImg={showErrorImg}
                isBorderNone={isBorderNone}
                isSubComponent={isSubComponent}
                modalBg={modalBg}
            // subComponent={subComponent}
            />
            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                comparisonScreen={comparisonScreen}
                summaryParagraph={summaryParagraph ? <p className={summaryParagraphStyles}>{summaryParagraph}</p> : ""}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                subHeaderMsg={subHeaderMsg ? <p className={SubHeaderMsgStylesPlus}>{subHeaderMsg}</p> : ""}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                fullWidth={fullWidth}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                footerButtonEnable={footerButtonEnable}
                skipAndNextButtonsEnable={skipAndNextButtonsEnable}
                gradientButton={gradientButton}
                largeImage={largeImage}
                subFooter={subFooter}
            />
            {isLoading && <Loader />}
            <Modal
                Fullheight={true}
                isOpen={isOptInModalOpen}
                onClose={closeOptInModal}
                alignItems={'items-center'}
                isClimbg={true}
                title={<p className={`${HeadingStyles} hidden sm:flex`}> {(alertButtonText == t('pause_covered_by_kudzu') || alertButtonText == t('pause_covered_by_kudzuPlus'))  ? 'Are you sure? ' : t('pauseSpendAlerts')}</p>}
                subtitle={
                    <p>
                        <span className={`${HeadingStyles} visible sm:hidden`}> {(alertButtonText == t('pause_covered_by_kudzu') || alertButtonText == t('pause_covered_by_kudzuPlus')) ? 'Are you sure? ' : t('pauseSpendAlerts')}</span><span className={SubHeadingStyles}>{modalHeading}</span>
                    </p>}
                // title={<p className={HeadingStyles}>
                //     {alertButtonText == t('pause_covered_by_kudzu') ? 'Are you sure?' : t('pauseSpendAlerts')}</p>}
                // subtitle={<p className={SubHeadingStyles}>{modalHeading}</p>}
                content={
                    <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <p className='lg:w-[454px] sm:w-[301px] w-[240px] font-hanken-grotesk lg:text-[20px]
                             md:text-[18px] sm:text-[14px] text-[16px] font-medium leading-[24px]
                              sm:leading-[28px] 
                              md:leading-[30px] text-[var(--alert-content-clr)] '>{alertContentText}</p>
                        <div className=' flex flex-col justify-center items-center w-full'>
                            <img src={(alertButtonText == t('pause_covered_by_kudzu') || alertButtonText == t('pause_covered_by_kudzuPlus')) ? appThemeData.isUmbrella : appThemeData.isman} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />
                            <div className=' flex flex-col justify-center items-center w-full'>

                                <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                    <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
                                sm:text-[15px] text-[16px] font-[500] 
                                sm:font-bold leading-[24px]  sm:leading-[12px] 
                                      md:leading-[16px] bg-[#2965FB] text-white
                                      cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" 
                                      type="button"
                                      onClick={() => toggleOnOrOff(selectedItem, selectedOptin)}
                                    >{alertButtonText}</button>
                                    <button type="button" className='font-hanken-grotesk   font-[500] 
                                    sm:font-bold leading-[24px] lg:text-[18px] md:text-[17px] 
                                    sm:text-[15px] text-[16px] sm:leading-[12px] border-[#2965FB] border-[2.5px] px-2 py-4 w-full sm:border-0 text-center
                                     md:leading-[16px] text-[var(--can-clr)] capitalize
                                      cursor-pointer' onClick={closeOptInModal}
                                    >{t('cancel')}</button>

                                </div>
                            </div>

                        </div>
                    </div>}
            />

            {/* //welcome back optin modal */}
            { isOptInWelcomBackModalOpen &&
                <Modal
                    Fullheight={true}
                    isOpen={isOptInWelcomBackModalOpen}
                    onClose={closeOptInModal}
                    alignItems={'items-center'}
                    isClimbg={true}
                    title={''}
                    subtitle={
                        <p>
                            <span className={`${HeadingStyles}`}> {t('Welcome_back')}</span>   <span className={`${SubHeadingStyles}`}>{t('Please_confirm_you’d_like_to_opt_back_in_to_Covered_by_Kudzu')}</span>
                        </p>}
                    // title={<p className={HeadingStyles}>
                    //     {alertButtonText == t('pause_covered_by_kudzu') ? 'Are you sure?' : t('pauseSpendAlerts')}</p>}
                    // subtitle={<p className={SubHeadingStyles}>{modalHeading}</p>}
                    content={
                        <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                            <p className='lg:w-[443px] sm:w-[301px] w-[240px] font-hanken-grotesk lg:text-[20px]
                             md:text-[18px] sm:text-[14px] text-[16px] font-medium leading-[24px]
                              sm:leading-[28px] 
                              md:leading-[30px] text-[var(--alert-content-clr)] '>{t('Get_even_more_protection_for_low')}</p>
                            <div className=' flex flex-col justify-center items-center w-full'>
                                <img src={appThemeData.isUmbrella} alt="complete" className='lg:w-[108px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />
                                <div className=' flex flex-col justify-center items-center w-full'>

                                    <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                        <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
                                sm:text-[15px] text-[16px] font-[500] 
                                sm:font-bold leading-[24px]  sm:leading-[12px] 
                                      md:leading-[16px] bg-[#2965FB] text-white
                                      cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" 
                                      type="button"
                                      onClick={() => { setIsOptInWelcomeBackModalOpen(false); setIsCoveredByKudzuDiscloserOpen(true)}}
                                        >{t('activate_covered_by_Kudzu+')}</button>
                                        <button type="button" className='font-hanken-grotesk   font-[500] 
                                    sm:font-bold leading-[24px] lg:text-[18px] md:text-[17px] 
                                    sm:text-[15px] text-[16px] sm:leading-[12px] border-[#2965FB] border-[2.5px] px-2 py-4 w-full sm:border-0 text-center
                                     md:leading-[16px] text-[var(--can-clr)] capitalize
                                      cursor-pointer' onClick={closeOptInModal}
                                        >{t('cancel')}</button>

                                    </div>
                                </div>

                            </div>
                        </div>}
                />}

            {/* inEleigible modal for covered by kudzu plus  */}

            <Modal
                isOpen={isCoveredByKudzuPlusIneligible}
                onClose={() => {
                    if (isCoveredByKudzuPlusIneligible) {
                        setIsCoveredByKudzuPlusIneligible(false)
                    }
                }}
                isClimbg={true}
                Fullheight={true}
                subtitle={<div className="">
                    <span className={SubHeadingStyles2}>{t('sorry')}, </span>
                    <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                    <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                        {t("you_need_minimum_100_spending")}  <Link to='/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions' state={{ name: 'Covered by Kudzu Terms and Conditions',
                    url:
                        userMembershipData?.membershipType === "Plus" ||
                            userMembershipData?.membershipType === "Trial"
                            ? "CoveredByKudzuPlusTerms"
                            : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey }} className='text-[var(--modal-text-highlight)] cursor-pointer underline'>{t('here')}</Link>.</p>
                </div>
                }
                content={<div>

                    <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt=""
                        className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                    <div className="flex flex-col justify-center items-center gap-8 w-full">
                        <Link
                            to='/AccountServices/Spending/TransferMoney'
                            className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            onClick={() => { setIsCoveredByKudzuPlusIneligible(false); }}
                            autoFocus
                        >
                            {t('Add_Money_to_Spending')}
                        </Link>
                        <Link
                            to='/Toolkit/ToolkitMenu'
                            className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--modal-text-highlight)] cursor-pointer flex justify-center items-center p-4 sm:border-[0px]  border-[#2965FB] border-[2.5px]`}
                            onClick={() => {
                                setIsCoveredByKudzuPlusIneligible(false);
                            }}
                        >
                            {t('back_to_climb')}
                        </Link>
                    </div>
                </div>}
            />

            <Modal
                isOpen={isOptOutModalOpen}
                onClose={closeOptOutModal}
                alignItems={'items-center'}
                isClimbg={true}
                // title={<p className={HeadingStyles}>{t('done_exclamation')}</p>}
                // subtitle={<p className={SubHeadingStyles}>{modalHeading}</p>}
                title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('done_exclamation')}</p>}
                subtitle={
                    <p>
                        <span className={`${HeadingStyles} visible sm:hidden`}> {t('done_exclamation')}</span><span className={SubHeadingStyles}>{modalHeading}</span>
                    </p>}
                content={
                    <>
                        <p className='font-hanken-grotesk w-[452px] mt-4 font-[400] sm:font-[500] 
                    leading-[24px] lg:text-[20px]
                    md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[22px]
                     md:leading-[28px] text-[var(--modalpq-colors)]'>{alertContentText}</p>
                        <div class="aspect-454/253">
                            <div className=' flex flex-col justify-center items-center w-full'>
                                <img className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' src={ (alertContentText == t('opt_out_of_covered_by_kudzu_msg') || alertContentText == t('you_may') ||  modalHeading == t('covered_by_kudzu_Plus_paused')) ? appThemeData.coveredBySuccess : appThemeData.SpendAlertsPauseSuccess} alt="complete"/>
                                <div className=' flex flex-col justify-center items-center w-full'>
                                    <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                                               <Link to='/Toolkit/ToolkitMenu' autoFocus className="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
                                        sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px]sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full flex justify-center items-center"
                                                                               >{alertButtonText}</Link>

                                        {/* {(alertContentText == t('you_can_resume_savings') || alertContentText == t('you_can_opt_back_in_covered_by_kudzu')) && <p className='font-hanken-grotesk text-[16px] font-[500] sm:font-bold leading-[24px] sm:text-[12px] sm:leading-[12px] md:text-[16px] md:leading-[16px] text-secondary-2 capitalize cursor-pointer' onClick={closeOptOutModal}
                                            tabIndex={0}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") closeOptOutModal();
                                            }}
                                        >{alertContentText == t('you_can_opt_back_in_covered_by_kudzu') ? t('opt_back_into_covered_by_kudzu') : t('resume_savings_habit')}</p>} */}

                                    </div>
                                </div>

                            </div>
                        </div>
                    </>}
            />

            <Modal isIframe={true}
                isOpen={showAgreementsModel}
                onClose={() => {setShowAgreementsModel(false); setIsCoveredByKudzuDiscloserOpen(true)}}
                title={false}
                content={<div className="h-[800px] w-full pt-16">
                    {(renderModel == "Link") && <iframe src={policyURL}
                        title="Embedded Website" className="w-full h-[800px] rounded-br-[4rem]"
                    />}
                    {
                        (renderModel == "HTML") && <div>{policyURL}</div>
                    }
                </div>
                }
            />

            <Modal
                isOpen={isCoveredByKudzuDiscloserOpen}
                Fullheight={true}
                onClose={closeModel}
                isClimbg={true}
                subtitle={
                    <span className={SubHeadingStyles}>{selectedItem === COVERED_BY_KUDZU ? t("coveredby_kudzu_terms") : t('coveredby_kudzu_Plus_terms')}</span>
                }
                content={
                    <div className="md:pt-1 sm:pt-1 pb-2">
                        <p className="font-hanken-grotesk lg:text-[16px] md:text-[16px] sm:text-[10] sm:leading-[16px]
                         text-[14px] leading-[20px] font-[500] sm:font-normal md:leading-[24px] mt-8 mb-16 text-[var(--cbk-review-color)]">{t("cbk_please_review")}</p>
                            <div className='flex flex-row gap-2 cursor-pointer mt-8'>
                            <label htmlFor="disclosure-agreement-checkbox" className="flex flex-row gap-2 cursor-pointer">
                                <input
                                    id="disclosure-agreement-checkbox"
                                    name="disclosure-agreement"
                                    type="checkbox"
                                    checked={disclosureAgrmt}
                                    onChange={(e) => { setDisclosureAgrmt(e.target.checked); if (!e.target.checked) { setinfoMessage('') } }}
                                    className="sr-only peer"
                                />
                                <span className="inline-block cursor-pointer">
                                    <img src={disclosureAgrmt ? RadialFill : appThemeData.NotAccept} alt=""
                                        className="h-[25px] w-[25px] sm:h-[23px] sm:w-[23px] md:h-[25px] md:w-[25px]"
                                        aria-hidden="true"
                                    />
                                </span>
                                <span className='sm:w-[25rem] w-full font-hanken-grotesk font-[500] sm:font-[700] text-[14px] 
                                leading-[20px] sm:text-[12px] sm:leading-[20px] md:text-[16px] md:leading-[24px]
                                 text-[var(--modal-text-heading-clr)]'>{t('i_have_read_and_agree')}
                                    <button type="button" onClick={() => { handleClick('userAgreement') }} className="text-[var(--modal-text-highlight)] font-hanken-grotesk underline"> {selectedItem === COVERED_BY_KUDZU ? t("coveredby_kudzu_terms") : t(('coveredby_kudzu_Plus_terms'))}</button></span>
                            </label>
                        </div>
                        {infoMessage &&
                            <div className='mb-2 w-4/5 self-center justify-center'>
                                {displayErrorMessage(infoMessage)}
                            </div>
                        }
                        <p className="font-hanken-grotesk lg:text-[15px] md:text-[16px] sm:text-[10] sm:leading-[16px]
                         text-[12px] leading-[20px] font-[500] sm:font-normal md:leading-[24px] mt-8 mb-16 text-[var(--cbk-review-color)]">{t("cbk_by_clicking")}</p>
                        <div className="flex justify-center text-center w-full items-center lg:mt-14 md:mt-12 mt-8">
                            <button
                                type="button"
                                className="w-full font-hanken-grotesk sm:font-bold font-[600] 
                                lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-white
                                 bg-[#2965FB] cursor-pointer flex justify-center items-center p-4 focus:outline-none  "
                                onClick={() => { if (disclosureAgrmt) { setinfoMessage(''); coveredByKudzuOptIn(selectedItem,isCoveredByKudzuOptedIn) } else { setinfoMessage(t('please_accept_coveredbykudzu_terms')) } }}
                                autoFocus
                            >
                                {selectedItem === COVERED_BY_KUDZU ? t('activate_cbk') : t('activate_covered_by_Kudzu+') }
                            </button>
                        </div>
                    </div>}
            />

            {/* these modals im working on  */}
            {isCoveredByKudzuIneligibleSetupSavings &&
                <Modal
                    isOpen={isCoveredByKudzuIneligibleSetupSavings}
                    onClose={() => { closeSkipModal(); setIsCoveredByKudzuIneligibleSetupSavings(false); }}
                    isClimbg={true}
                    Fullheight={true}
                    subtitle={<div className="">
                        <span className={SubHeadingStyles2}>{t('sorry')}, </span>
                        <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                        <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                            {LineBreaks(t("you_need_savings_account_updated"))}</p>
                    </div>
                    }
                    content={<div>

                        <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt=""
                            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                        <div className="flex flex-col justify-center items-center gap-8 w-full">
                            <button
                                type="button"
                                className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                                onClick={() => {
                                    setIsCoveredByKudzuIneligibleSetupSavings(false);
                                    if (kudzuPlusTrue) {
                                        showAlertModalPlus(true, "", <p className='mb-6'><span className='text-[var(--modal-text-highlight)]'>{t('Let’s_get_started_climb')}</span>{" "}{t('with_creating_a_Kudzu+_savings_account')}</p>,
                                            t("set_aside_money_for_things_that_matter"),
                                            false, false, t("enroll"), t("may_be_later"), false,
                                            require('../../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
                                            '', true, '', false, false, false, true, <Link
                                                to='/SetupSavingsAccount'
                                                onClick={() => {
                                                    setShowPlusModal(false); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('came_from_climb') } });
                                                }}
                                                className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[16px]
                            text-white cursor-pointer flex justify-end items-center w-full" >
                                            {t('next')} <img
                                                src={ArrowWhite}
                                                className="md:w-[9px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[9px] h-[14px] ml-2"
                                                alt="" />
                                        </Link>
                                        );
                                    }
                                    else {
                                        setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);

                                    }
                                }}
                                autoFocus
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        setIsCoveredByKudzuIneligibleSetupSavings(false);
                                        setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);
                                        event.stopPropagation();
                                    }
                                }}
                            >
                                {t('enroll_in_savings_account')}
                            </button>
                            <Link
                                to='/Toolkit/ToolkitMenu'
                                className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--modal-text-highlight)] cursor-pointer flex justify-center items-center p-4  sm:border-[0px]  border-[#2965FB] border-[2.5px]`}
                                onClick={() => {
                                    setIsCoveredByKudzuIneligibleSetupSavings(false);
                                }}
                            >
                                {t('back_to_climb')}
                            </Link>
                        </div>
                    </div>}
                />}
            {isCoveredByKudzuIneligibleSetupSavingsPostPopup && <Modal
                // bgColor={'bg-[#FEFAEE]'}
                isOpen={isCoveredByKudzuIneligibleSetupSavingsPostPopup}
                onClose={() => { closeSkipModal(); setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false); }}
                isClimbg={true}
                Fullheight={true}
                subtitle={<div className="">
                    <span className={SubHeadingStyles2}>{t('lets_get_started').replace('!', '')} </span>
                    <span className={SubHeadingStyles}>{t("with_creating_a_new_account")}</span>
                    <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                        {t("set_aside_money_for_things_that_matter")}</p>
                </div>
                }
                content={<div>

                    <img src={require('../../../../assets/images/kudzu_piggy_bank.png')} className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                    <div className="flex flex-col justify-center items-center gap-8 w-full">
                        <Link
                            to='/SetupSavingsAccount'
                            className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            onClick={() => {
                                setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('came_from_climb') } });
                            }}
                            autoFocus
                        >
                            {t('continue')}
                        </Link>
                    </div>
                </div>}
            />}

            {isCoveredByKudzuIneligible && <Modal
                isOpen={isCoveredByKudzuIneligible}
                onClose={closeCustomAlertModal}
                isClimbg={true}
                Fullheight={true}
                subtitle={<div className="">
                    <span className={SubHeadingStyles2}>{t('sorry')}, </span>
                    <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                    <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                        {t("you_need_minimum_50")}</p>
                </div>
                }
                content={<div>

                    <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon} alt=""
                        className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                    <div className="flex flex-col justify-center items-center gap-8 w-full">
                        <Link
                            to='/AccountServices/Spending/TransferMoney'
                            className="focus:outline-none   w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            autoFocus
                        >
                            {'Add Money to Savings'}
                        </Link>
                        <Link
                            to='/Toolkit/ToolkitMenu'
                            className="w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            onClick={() => {
                                setIsCoveredByKudzuIneligible(false);
                            }}>
                            {/* {'Maybe later'} */}
                            {t('back_to_climb')}
                        </Link>
                    </div>
                </div>}
            />}

            {isCoveredByKudzuPlusModalOpen1 &&<Modal
                isOpen={isCoveredByKudzuPlusModalOpen1}
                onClose={debounce(closeCBKPlusModals, 100)}
                isClimbg={true}
                title={<p className={SubHeadingStyles}>{t('Get_more_protection')} <span className={SubHeadingStyles2}>{t("CBK+")}</span> {t('upgrade')}</p> }
                subtitle={<p className={`${SubHeaderMsgStyles} mt-[30px]`}>{t('Eligible_Kudzu+_users_may_activate_additional_coverage')}</p> }
                content={<div className=" m-auto md:pt-16 pt-8 pb-5 h-auto w-full flex flex-col">
                    <img src={coveredBykudzuplus1}
                        className="block sm:m-auto mx-auto " alt="" />
                    <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
                            <div>
                            <p className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)] md:relative md:right-[90px]"                                >
                                {t('questions_see_our')} <Link to='/Help/FAQ' onClick={() => { logFirebaseEvents("Covered_By_Kudzu_Plus", "Faq_Covered_By_Kudzu_Plus_Clicked", "Faq_Covered_By_Kudzu_Plus_Clicked","", ""); }}
                                    className="text-[#94C3E8] underline">{t('faq')}</Link>
                            </p>

                            <Link
                                to='/Help/FAQ'
                                className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[#94C3E8]"
                            >{t('faq')}</Link>
                        </div>

                        <div className="">
                            <div className="sm:absolute md:right-[-6rem] sm:right-[-4rem] flex sm:justify-end justify-end md:gap-14 sm:gap-8">
                                <button type="button" className="sm:flex hidden font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
 text-[#779CE5]  items-center disabled"  onClick={debounce(handleActivateCoveredByKudzuPlus, 100)}> {t('skip')}</button>

                                <button type="button" className="font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--transactions-filter-blue-text)]
 cursor-pointer flex items-center focus:outline-none  " onClick={debounce(() => {setIsCoveredByKudzuPlusModalOpen1(false);  setIsCoveredByKudzuPlusModalOpen2(true);}, 100)} autoFocus> {t('continue')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
  md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt=""/> </button></div></div>

                    </div>
                </div>}
            />}
            {isCoveredByKudzuPlusModalOpen2 &&<Modal
                isOpen={isCoveredByKudzuPlusModalOpen2}
                onClose={debounce(closeCBKPlusModals, 100)}
                isClimbg={true}
                subtitle={<p className={SubHeadingStyles}>{t('To_maintain_coverage_you’ll_need')} <span className={`${SubHeadingStyles2}`}>{t("100_or_more_in_direct_eposits")}</span> {t('to_your_spending_account_each_month')}</p> }
                content={<div className=" m-auto md:pt-16 pt-8 pb-5 h-auto w-full flex flex-col">
                    <img src={coveredBykudzuplus2}
                        className="block sm:m-auto mx-auto mt-10" alt="" />
                    <div className="w-full flex flex-row justify-between lg:mt-20 md:mt-20 mt-20">
                        <div>
                            <p className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)] md:relative md:right-[90px]"
                            >
                                {t('questions_see_our')} <Link to='/Help/FAQ' onClick={() => { logFirebaseEvents("Covered_By_Kudzu_Plus", "Faq_Covered_By_Kudzu_Plus_Clicked", "Faq_Covered_By_Kudzu_Plus_Clicked","", ""); }}
                                    className="text-[#94C3E8] underline">{t('faq')}</Link>
                            </p>

                            <Link
                                to='/Help/FAQ'
                                className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[#94C3E8]"
                            >{t('faq')}</Link>
                        </div>

                        <div className="">
                            <div className="sm:absolute md:right-[-6rem] sm:right-[-4rem] flex sm:justify-end justify-end md:gap-14 sm:gap-8">
                                <button type="button" className="sm:flex hidden font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
 text-[#779CE5]  items-center disabled"  onClick={debounce(handleActivateCoveredByKudzuPlus, 100)}> {t('skip')}</button>

                                <button type="button" className="font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--transactions-filter-blue-text)]
 cursor-pointer flex items-center focus:outline-none  " onClick={debounce(handleActivateCoveredByKudzuPlus, 100)} autoFocus> {t('activate')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
  md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt=""/> </button></div></div>

                    </div>
                </div>}
            />}
        </>



    )
}

export default withOidcSecure(ClimbSettings)